// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { MemberProvider } from './contexts/MemberContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { MemberSettingsProvider } from './contexts/MemberSettingsContext';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <MemberSettingsProvider>
          <MemberProvider>
            <NotificationProvider>
              {/*<ThemeSettings>*/}
              {/* <ProgressBarStyle />
          <ScrollToTop />*/}
              <Router />
              {/*</ThemeSettings>*/}
            </NotificationProvider>
          </MemberProvider>
        </MemberSettingsProvider>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
